
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

/**
 * Protège toutes les routes enfants sous /app/admin.
 * Autorise uniquement les administrateurs.
 */
export default function AdminRoute() {
  const user = useAuthStore((state) => state.user)
  const isAdmin = useAuthStore((state) => state.isAdmin())
  const isInitialized = useAuthStore((state) => state.isInitialized)

  // Attendre la vérification de l'authentification.
  if (!isInitialized) {
    return null
  }

  // Refuser l'accès aux utilisateurs non administrateurs.
  if (!user || !isAdmin) {
    return <Navigate to="/app/overview" replace />
  }

  // Autoriser les routes enfants Admin.
  return <Outlet />
}
